const { protocol, hostname } = window.location;

const isHttps = protocol === 'https:';
const baseProtocol = isHttps ? 'https' : 'http';
const wsProtocol = isHttps ? 'wss' : 'ws';

const {
  REACT_APP_BASE_URL_PORT,
  REACT_APP_SOCKET_URL_PORT,
  REACT_APP_WSS_URL_PORT,
  REACT_APP_BASE_URL,
  REACT_APP_SOCKET_URL,
  REACT_APP_WSS_URL,
  REACT_APP_IS_DYNAMIC_URL
} = process.env;

const isDynamic = REACT_APP_IS_DYNAMIC_URL === 'true';

const buildUrl = (proto, port) => `${proto}://${hostname}:${port}`;

const config = {
  BASE_URL: isDynamic ? `${buildUrl(baseProtocol, REACT_APP_BASE_URL_PORT)}/` : REACT_APP_BASE_URL,
  SOCKET_URL: isDynamic
    ? `${buildUrl(baseProtocol, REACT_APP_SOCKET_URL_PORT)}/`
    : REACT_APP_SOCKET_URL,
  WSS_URL: isDynamic ? buildUrl(wsProtocol, REACT_APP_WSS_URL_PORT) : REACT_APP_WSS_URL
};

export default config;
